// Configuration
const SHOPIFY_DOMAIN = '86cb8c-e4.myshopify.com';
const STOREFRONT_ACCESS_TOKEN = '42cc81e7c9e1a4514b45bf68d9281d2d';
const API_VERSION = '2024-10';

const variantInfo = {
    'Ano Spinning Disc': '5 remappable keys + infinite rotation for maximum versatility.',
    'Small Trackpad': 'Compact size, full movement range, plus WPM animation on the OLED.',
    'Large Trackpad': 'More space to move — ideal for broader gestures and larger motions.',
    'MX': 'Wide range of switches and keycaps for full customisation.',
    'LP': 'Supports low-profile switches: Choc v1/ v2 and some lower-profile MX (Cherry, THT, LPF, XVX).',
    'PP': 'Soft typing feel.',
    'Fr4': 'Balanced and neutral feel.',
    'Carbon Fibre': 'Premium, rigid feel without finger fatigue.',
    '50% OFF! LPV1 - Kailh Red Pro Linear Choc 1350 35g': 'Budget friendly & light.',
    'LPV2 - Silent Tactile Whale Mini 1353 55g': 'Soft tactile, quiet for office.',
    'LPV2 - Silent Linear Islet Mini 1353 43g': 'Smooth, silent linear, quiet for office.',
    'LPV2 - Silent Linear Pink Islet Mini 1353 35g': 'Lightest v2 silent linear, quiet for office use.',
    'LPV2 - Kailh Linear Raptor Mini 1353 37g': 'Ultra-low height (1mm lower) with fast response.',
    'LPV2 - Kailh Tactile Black Cloud 1353 55g': 'Smooth tactile pre-lubed, dimmer shine-through.',
    'LPV2 - Kailh Tactile Winter Mini 1353 50g': 'Lighter tactile than Black Cloud, smooth pre-lubed.',
    'LPV2 - Kailh Clicky Autumn Mini 45g': 'Satisfying clicky sound, smooth, pre-lubed.',
    'LPV1 - Kailh Brown Tactile Choc 1350 50g': 'Standard budget tactile switch.',
    'LPV1 - Kailh White Clicky Choc 1350 50g': 'Low-profile clicky switch, satisfying feel.',
    'MX - Monx x Bsun MY Silent Linear 43g': 'Malaysian switch, silent and not mushy, quiet for office.',
    'MX - Kailh Whale Silent Tactile 60g': 'Classic silent tactile, office-suitable.',
    'Nuphy nSA LP Canopus Shinethrough': 'South-facing legend keycaps, supports full Sofle layout (some legends may vary).',
    'Southshine LPF R2 Shinethrough': 'XCMKB-customised, legends for Sofle keyboard, supports QWERTY & Colemak.',
    'LP (Poron+IXPE)': 'Cushions bottom-out, reduces fatigue, dampen vibration, eases switch installation.',
    'MX (Poron+IXPE)': 'Cushions bottom-out, reduces fatigue, dampen vibration, eases switch installation, improves acoustic feel.',
    '3D Case': 'PLA-printed side cover for dust protection and PCB guard; hollow bottom design supports custom bottom plates, file available supports local re-printing in alternate colours/materials.',
    'Frosted Acrylic Bottom Plate': 'Budget-friendly bottom cover in clear frosted acrylic.',
    'Sofle v2 with clear acrylic': 'Premium bottom cover with clear acrylic layer, supports MagSafe stand and flexible tenting. Slight finish marks may occur; rust resistant. *MagSafe stand not included.'
};

let products = {basePCB: [], modules: [], switchPlate: [], switchType: [], switches: [], keycapsMX: [], keycapsLPV1: [], case3D: [], bottomPlate: [], dampeningKit: []};
let selected = {basePCB: null, leftModule: null, rightModules: [], switchType: 'MX', selectedSwitch: null, switchPlates: [], switches: [], keycaps: [], dampeningKit: null, case3D: null, bottomPlates: []};
let currentPreset = 'custom'; // Track current preset selection
let isApplyingPreset = false; // Flag to prevent change detection during preset application

// Preset configurations
const presets = {
    starter: {
        name: 'Starter',
        basePCB: 'gid://shopify/ProductVariant/47342431797507', // Pre-assembled PCB
        leftModule: 'Ano Spinning Disc',
        rightModules: ['Small Trackpad + Oled'],
        switchType: 'LP',
        switchPlates: ['Fr4'],
        dampeningKit: null,
        case3D: null,
        bottomPlates: ['Frosted Acrylic Bottom Plate']
    },
    standard: {
        name: 'Standard',
        basePCB: 'gid://shopify/ProductVariant/47342431797507', // Pre-assembled PCB
        leftModule: 'Ano Spinning Disc',
        rightModules: ['Small Trackpad + Oled'],
        switchType: 'LP',
        switchPlates: ['Fr4'],
        dampeningKit: 'auto', // Will auto-select based on switch type
        case3D: '3D Case',
        bottomPlates: ['Martensitic Steel Plate - Sofle v2 with clear acrylic']
    },
    signature: {
        name: 'Signature',
        basePCB: 'gid://shopify/ProductVariant/47342431797507', // Pre-assembled PCB
        leftModule: 'Ano Spinning Disc',
        rightModules: ['Small Trackpad + Oled'],
        switchType: 'LP',
        switchPlates: ['Carbon Fibre'],
        dampeningKit: 'auto', // Will auto-select based on switch type
        case3D: '3D Case',
        bottomPlates: ['Martensitic Steel Plate - Sofle v2 with clear acrylic']
    }
};

function toggleCollapse(id) {
    const content = document.getElementById(id);
    const icon = document.getElementById(id.replace('-collapse', '-icon'));
    const isCollapsing = !content.classList.contains('collapsed');
    content.classList.toggle('collapsed');
    icon.classList.toggle('collapsed');

    // Update summary when collapsing
    if (isCollapsing) {
        updateCollapsedSummary(id);
    } else {
        // Hide summary when expanding
        const summaryId = id.replace('-collapse', '-summary');
        const summary = document.getElementById(summaryId);
        if (summary) summary.classList.remove('show');
    }
}

function updateCollapsedSummary(collapseId) {
    const summaryId = collapseId.replace('-collapse', '-summary');
    const summary = document.getElementById(summaryId);
    if (!summary) return;

    // Check if the section is currently collapsed
    const content = document.getElementById(collapseId);
    const isCollapsed = content && content.classList.contains('collapsed');

    // Only show summary if section is collapsed
    if (!isCollapsed) {
        summary.classList.remove('show');
        return;
    }

    // Map collapse IDs to their checkbox groups
    const groupMappings = {
        'modules-collapse': ['left-module-group', 'right-module-group'],
        'switch-plate-collapse': ['switch-plate-group'],
        'switches-collapse': ['switches-group'],
        'keycaps-collapse': ['keycaps-group'],
        'dampening-collapse': ['dampening-group'],
        'case-collapse': ['case-3d-group'],
        'bottom-collapse': ['bottom-plate-group']
    };

    const groupIds = groupMappings[collapseId];
    if (!groupIds) return;

    const selectedTitles = [];

    // Collect all checked items from relevant groups
    groupIds.forEach(groupId => {
        const group = document.getElementById(groupId);
        if (!group) return;

        const checkedInputs = group.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
        checkedInputs.forEach(input => {
            const labelWrapper = input.parentElement.querySelector('.checkbox-label-wrapper');
            if (labelWrapper) {
                const label = labelWrapper.querySelector('.checkbox-label');
                if (label) {
                    selectedTitles.push(label.textContent.trim());
                }
            } else {
                // Fallback: try finding label by id
                const label = input.parentElement.querySelector('.checkbox-label');
                if (label) {
                    selectedTitles.push(label.textContent.trim());
                }
            }
        });
    });

    // Update summary display (only when collapsed)
    if (selectedTitles.length > 0) {
        summary.textContent = selectedTitles.join(', ');
        summary.classList.add('show');
    } else {
        summary.textContent = '';
        summary.classList.remove('show');
    }
}

function extractVariantId(gid) {
    if (!gid) return null;
    const parts = gid.split('/');
    return parts[parts.length - 1];
}

function getVariantInfo(variantTitle) {
    // Try exact match first
    if (variantInfo[variantTitle]) return variantInfo[variantTitle];

    // Try removing " (Out of stock)" or other suffixes
    const cleanTitle = variantTitle.replace(/ \(.*?\)$/g, '').trim();
    if (variantInfo[cleanTitle]) return variantInfo[cleanTitle];

    // For partial matches, sort keys by length (longest first) to match most specific first
    const sortedKeys = Object.keys(variantInfo).sort((a, b) => b.length - a.length);
    for (const key of sortedKeys) {
        if (variantTitle.includes(key)) return variantInfo[key];
    }

    return null;
}

function createInfoIcon(tooltipText) {
    if (!tooltipText) return null;
    const infoIcon = document.createElement('span');
    infoIcon.className = 'info-icon';
    const tooltip = document.createElement('span');
    tooltip.className = 'info-tooltip';
    tooltip.textContent = tooltipText;

    // Append tooltip to body instead of icon to escape overflow clipping
    document.body.appendChild(tooltip);

    // Store reference to cleanup later
    infoIcon._tooltip = tooltip;

    const showTooltip = () => {
        tooltip.style.display = 'block';
        const rect = infoIcon.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        // Position tooltip to the left of the icon, aligned to right edge
        const left = rect.right - tooltipRect.width;
        const top = rect.top - tooltipRect.height - 14;

        // Keep within viewport bounds
        const finalLeft = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
        const finalTop = Math.max(10, top);

        tooltip.style.left = finalLeft + 'px';
        tooltip.style.top = finalTop + 'px';
    };

    const hideTooltip = () => {
        tooltip.style.display = 'none';
    };

    infoIcon.addEventListener('mouseenter', showTooltip);
    infoIcon.addEventListener('mouseleave', hideTooltip);
    infoIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        const wasActive = infoIcon.classList.contains('active');
        document.querySelectorAll('.info-icon.active').forEach(icon => {
            icon.classList.remove('active');
            if (icon._tooltip) icon._tooltip.style.display = 'none';
        });
        if (!wasActive) {
            infoIcon.classList.add('active');
            showTooltip();
        } else {
            hideTooltip();
        }
    });
    return infoIcon;
}

document.addEventListener('click', () => {
    document.querySelectorAll('.info-icon.active').forEach(icon => icon.classList.remove('active'));
});
function createInlineImage(itemElement, variant, productHandle) {
    if (!variant.image || !variant.image.url) return;
    const imagePreview = document.createElement('div');
    imagePreview.className = 'inline-image-preview';
    const link = document.createElement('a');
    const variantId = extractVariantId(variant.id);
    link.href = variantId ? `https://xcmkb.com/products/${productHandle}?variant=${variantId}` : `https://xcmkb.com/products/${productHandle}`;
    link.target = '_blank';
    link.style.display = 'block';
    link.style.textDecoration = 'none';
    const img = document.createElement('img');
    img.src = variant.image.url;
    img.alt = variant.title;
    link.appendChild(img);
    const caption = document.createElement('p');
    caption.innerHTML = `${variant.title} <span style="color: #0058a3; font-size: 11px;">(Click image to view product page)</span>`;
    imagePreview.appendChild(link);
    imagePreview.appendChild(caption);
    itemElement.parentNode.insertBefore(imagePreview, itemElement.nextSibling);
}

// GraphQL query function
async function fetchProduct(handle) {
    const query = `
        query {
            productByHandle(handle: "${handle}") {
                title
                handle
                variants(first: 50) {
                    edges {
                        node {
                            id
                            title
                            sku
                            priceV2 {
                                amount
                                currencyCode
                            }
                            availableForSale
                            quantityAvailable
                            image {
                                url
                                altText
                            }
                        }
                    }
                }
            }
        }
    `;

    const response = await fetch(`https://${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({ query })
    });

    const data = await response.json();
    const product = data.data.productByHandle;

    // Get the customer's country for market-specific pricing
    const country = window.Shopify && window.Shopify.country ? window.Shopify.country : 'MY';

    // Apply 10% markup for non-Malaysia markets
    if (country !== 'MY' && product && product.variants) {
        product.variants.edges.forEach(edge => {
            if (edge.node && edge.node.priceV2) {
                const originalPrice = parseFloat(edge.node.priceV2.amount);
                edge.node.priceV2.amount = (originalPrice * 1.1).toFixed(2);
            }
        });
    }

    return product;
}

// Load all products
async function loadProducts() {
    try {
        // Fetch all products
        const [basePCB, modules, switchPlate, switchType, casing, steelPlate, dampeningKit, switches, mxKeycaps, lpv1Keycaps] = await Promise.all([
    fetchProduct('sofleplus2'),
    fetchProduct('module'),
    fetchProduct('switch-plate'),
    fetchProduct('sofleplus2-switch-type'),  // ADD THIS LINE
    fetchProduct('sofle-casing'),
    fetchProduct('martensitic-steel-plate'),
    fetchProduct('vibration-sound-dampening-kit'),
    fetchProduct('switches'),
    fetchProduct('mx-keycaps'),
    fetchProduct('kailh-choc-v1-low-profile-keycap-set')
]);

        // Store base PCB variants (excluding the trackpad upgrade, only in stock)
        products.basePCB = basePCB.variants.edges
            .map(edge => edge.node)
            .filter(variant => !variant.title.toLowerCase().includes('trackpad') && variant.availableForSale);

        // Store module variants
        products.modules = modules.variants.edges.map(edge => edge.node);

        // Store switch type variants
        products.switchType = switchType.variants.edges.map(edge => edge.node);

        // Verify hardcoded variant IDs match Shopify data
console.log('Switch Type Variants from Shopify:', products.switchType);
const mxVariant = products.switchType.find(v => v.id.includes('47578511704323'));
const lpVariant = products.switchType.find(v => v.id.includes('47578511671555'));
if (!mxVariant || !lpVariant) {
    console.warn('⚠️ WARNING: Hardcoded Switch Type variant IDs do not match Shopify!');
    console.warn('MX Expected: 47578511704323, Found:', mxVariant?.id);
    console.warn('LP Expected: 47578511671555, Found:', lpVariant?.id);
}

        // Store switch plate variants (only in stock)
        products.switchPlate = switchPlate.variants.edges
            .map(edge => ({...edge.node, productHandle: switchPlate.handle}))
            .filter(variant => variant.availableForSale);

        // Store switches (all variants)
        products.switches = switches.variants.edges.map(edge => ({...edge.node, productHandle: switches.handle}));

        // Store MX keycaps (SKU contains LPV2MX)
        products.keycapsMX = mxKeycaps.variants.edges
            .map(edge => ({...edge.node, productHandle: mxKeycaps.handle}))
            .filter(variant => variant.sku && variant.sku.includes('LPV2MX'));

        // Store LPV1 keycaps (excluding individual Blanks)
        const lpv1All = lpv1Keycaps.variants.edges.map(edge => ({...edge.node, productHandle: lpv1Keycaps.handle}));

        // Filter out individual blank variants
        products.keycapsLPV1 = lpv1All.filter(variant =>
            !variant.title.includes('MBK Blanks') && !variant.title.includes('CFX Blanks')
        );

        // Create virtual MBK Black Blanks Sofle Bundle
        const mbkBlack1u = lpv1All.find(v => v.title === 'MBK Blanks (Black 1u x10)');
        const mbkBlackHoming = lpv1All.find(v => v.title === 'MBK Blanks (Black 1uh Homing  x2)');
        const mbkBlackThumb = lpv1All.find(v => v.title === 'MBK Blanks (Black 1.5u Convex Thumb x2)');

        if (mbkBlack1u && mbkBlackHoming && mbkBlackThumb) {
            // Check if sufficient stock for bundle: 6 sets of 1u, 1 set of homing, 1 set of thumb
            const has1uStock = mbkBlack1u.availableForSale && mbkBlack1u.quantityAvailable >= 6;
            const hasHomingStock = mbkBlackHoming.availableForSale && mbkBlackHoming.quantityAvailable >= 1;
            const hasThumbStock = mbkBlackThumb.availableForSale && mbkBlackThumb.quantityAvailable >= 1;

            const bundleAvailable = has1uStock && hasHomingStock && hasThumbStock;

            // Calculate bundle price: 6x 1u + 1x homing + 1x thumb
            const bundlePrice = (parseFloat(mbkBlack1u.priceV2.amount) * 6) +
                               parseFloat(mbkBlackHoming.priceV2.amount) +
                               parseFloat(mbkBlackThumb.priceV2.amount);

            // Create virtual bundle variant
            const mbkSofleBundle = {
                id: 'bundle-mbk-black-sofle',
                title: 'MBK Black Blanks Sofle Bundle',
                sku: 'KC-LPV1-MBK-SOFLE-BUNDLE',
                priceV2: {
                    amount: bundlePrice.toString(),
                    currencyCode: 'MYR'
                },
                availableForSale: bundleAvailable,
                quantityAvailable: bundleAvailable ? Math.min(
                    Math.floor(mbkBlack1u.quantityAvailable / 6),
                    mbkBlackHoming.quantityAvailable,
                    mbkBlackThumb.quantityAvailable
                ) : 0,
                // Store component IDs for cart
                bundleComponents: [
                    { id: mbkBlack1u.id, quantity: 6, title: mbkBlack1u.title },
                    { id: mbkBlackHoming.id, quantity: 1, title: mbkBlackHoming.title },
                    { id: mbkBlackThumb.id, quantity: 1, title: mbkBlackThumb.title }
                ]
            };

            // Add bundle to keycaps
            products.keycapsLPV1.push(mbkSofleBundle);
        }

        // Create virtual CFX Black Blanks Sofle Bundle
        const cfxBlack1u = lpv1All.find(v => v.title === 'CFX Blanks (Black 1ux10)');
        const cfxBlackHoming = lpv1All.find(v => v.title === 'CFX Blanks (Black 1uh Homing x2)');
        const cfxBlackThumb = lpv1All.find(v => v.title === 'CFX Blanks (Black 1.5u Thumb x2)');

        if (cfxBlack1u && cfxBlackHoming && cfxBlackThumb) {
            // Check if sufficient stock for bundle: 6 sets of 1u, 1 set of homing, 1 set of thumb
            const has1uStock = cfxBlack1u.availableForSale && cfxBlack1u.quantityAvailable >= 6;
            const hasHomingStock = cfxBlackHoming.availableForSale && cfxBlackHoming.quantityAvailable >= 1;
            const hasThumbStock = cfxBlackThumb.availableForSale && cfxBlackThumb.quantityAvailable >= 1;

            const bundleAvailable = has1uStock && hasHomingStock && hasThumbStock;

            // Calculate bundle price: 6x 1u + 1x homing + 1x thumb
            const bundlePrice = (parseFloat(cfxBlack1u.priceV2.amount) * 6) +
                               parseFloat(cfxBlackHoming.priceV2.amount) +
                               parseFloat(cfxBlackThumb.priceV2.amount);

            // Create virtual bundle variant
            const cfxSofleBundle = {
                id: 'bundle-cfx-black-sofle',
                title: 'CFX Black Blanks Sofle Bundle',
                sku: 'KC-LPV1-CFX-SOFLE-BUNDLE',
                priceV2: {
                    amount: bundlePrice.toString(),
                    currencyCode: 'MYR'
                },
                availableForSale: bundleAvailable,
                quantityAvailable: bundleAvailable ? Math.min(
                    Math.floor(cfxBlack1u.quantityAvailable / 6),
                    cfxBlackHoming.quantityAvailable,
                    cfxBlackThumb.quantityAvailable
                ) : 0,
                // Store component IDs for cart
                bundleComponents: [
                    { id: cfxBlack1u.id, quantity: 6, title: cfxBlack1u.title },
                    { id: cfxBlackHoming.id, quantity: 1, title: cfxBlackHoming.title },
                    { id: cfxBlackThumb.id, quantity: 1, title: cfxBlackThumb.title }
                ]
            };

            // Add bundle to keycaps
            products.keycapsLPV1.push(cfxSofleBundle);
        }

        // Store individual dampening kit components
        const dampeningAll = dampeningKit.variants.edges.map(edge => edge.node);

        // Find individual components
        const ixpeSwitchPad = dampeningAll.find(v => v.title === 'IXPE Switch Pad Layer');
        const lpPoronFoam = dampeningAll.find(v => v.title === 'LP Poron Foam');
        const mxPoronFoam = dampeningAll.find(v => v.title === 'MX Poron Foam');

        products.dampeningKit = [];

        // Create virtual LP (Poron+IXPE) bundle
        if (ixpeSwitchPad && lpPoronFoam) {
            const hasIxpeStock = ixpeSwitchPad.availableForSale && ixpeSwitchPad.quantityAvailable >= 1;
            const hasLpPoronStock = lpPoronFoam.availableForSale && lpPoronFoam.quantityAvailable >= 1;
            const bundleAvailable = hasIxpeStock && hasLpPoronStock;

            const bundlePrice = parseFloat(ixpeSwitchPad.priceV2.amount) + parseFloat(lpPoronFoam.priceV2.amount);

            const lpBundle = {
                id: 'bundle-lp-poron-ixpe',
                title: 'LP (Poron+IXPE)',
                sku: 'DAMPENING-LP-BUNDLE',
                priceV2: {
                    amount: bundlePrice.toString(),
                    currencyCode: 'MYR'
                },
                availableForSale: bundleAvailable,
                quantityAvailable: bundleAvailable ? Math.min(
                    ixpeSwitchPad.quantityAvailable,
                    lpPoronFoam.quantityAvailable
                ) : 0,
                bundleComponents: [
                    { id: ixpeSwitchPad.id, quantity: 1, title: ixpeSwitchPad.title },
                    { id: lpPoronFoam.id, quantity: 1, title: lpPoronFoam.title }
                ]
            };
            products.dampeningKit.push(lpBundle);
        }

        // Create virtual MX (Poron+IXPE) bundle
        if (ixpeSwitchPad && mxPoronFoam) {
            const hasIxpeStock = ixpeSwitchPad.availableForSale && ixpeSwitchPad.quantityAvailable >= 1;
            const hasMxPoronStock = mxPoronFoam.availableForSale && mxPoronFoam.quantityAvailable >= 1;
            const bundleAvailable = hasIxpeStock && hasMxPoronStock;

            const bundlePrice = parseFloat(ixpeSwitchPad.priceV2.amount) + parseFloat(mxPoronFoam.priceV2.amount);

            const mxBundle = {
                id: 'bundle-mx-poron-ixpe',
                title: 'MX (Poron+IXPE)',
                sku: 'DAMPENING-MX-BUNDLE',
                priceV2: {
                    amount: bundlePrice.toString(),
                    currencyCode: 'MYR'
                },
                availableForSale: bundleAvailable,
                quantityAvailable: bundleAvailable ? Math.min(
                    ixpeSwitchPad.quantityAvailable,
                    mxPoronFoam.quantityAvailable
                ) : 0,
                bundleComponents: [
                    { id: ixpeSwitchPad.id, quantity: 1, title: ixpeSwitchPad.title },
                    { id: mxPoronFoam.id, quantity: 1, title: mxPoronFoam.title }
                ]
            };
            products.dampeningKit.push(mxBundle);
        }

        // Store 3D Case (all variants, including out of stock)
        products.case3D = casing.variants.edges
            .filter(edge => edge.node.title.includes('3D Case'))
            .map(edge => edge.node);

        // Store Bottom Plate options (all variants including out of stock)
        products.bottomPlate = [
            // Frosted Acrylic from casing (excluding unwanted variants)
            ...casing.variants.edges
                .filter(edge => {
                    const title = edge.node.title;
                    return title.includes('Frosted Acrylic') &&
                           !title.includes('Sofle Stacked Acrylic');
                })
                .map(edge => edge.node),
            // Martensitic Steel Plate - only Sofle variants (exclude Corne)
            ...steelPlate.variants.edges
                .filter(edge => {
                    const title = edge.node.title;
                    // Include Sofle variants, exclude Corne and Stacked Acrylic
                    return (title.includes('Sofle') || title.includes('sofle')) &&
                           !title.includes('Stacked');
                })
                .map(edge => {
                    const title = edge.node.title;
                    // Return with descriptive title
                    if (title === 'Sofle v2 with clear acrylic') {
                        return {
                            ...edge.node,
                            title: 'Martensitic Steel Plate - Sofle v2 with clear acrylic'
                        };
                    }
                    // Keep original title for any other Sofle variants
                    return {
                        ...edge.node,
                        title: `Martensitic Steel Plate - ${title}`
                    };
                })
        ];

        // Populate UI
        populateBasePCB();
        populateModules();
        populateSwitchType();
        populateSwitchPlates();
        populateSwitches();
        populateKeycaps();
        populateDampeningKit();
        populateCase3D();
        populateBottomPlate();

        // Initialize presets after all products are loaded
        initializePresets();

        // Show configurator
        document.getElementById('loading').style.display = 'none';
        document.getElementById('configurator').style.display = 'block';

    } catch (error) {
        console.error('Error loading products:', error);
        document.getElementById('loading').style.display = 'none';
        document.getElementById('error').style.display = 'block';
        document.getElementById('error').textContent = 'Failed to load products. Please refresh the page.';
    }
}

// Populate Base PCB dropdown
function populateBasePCB() {
    const select = document.getElementById('base-pcb');
    const preselectedVariantId = 'gid://shopify/ProductVariant/47342431797507';

    products.basePCB.forEach(variant => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title} - RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;
        option.dataset.price = variant.priceV2.amount;
        option.dataset.title = variant.title;

        // Pre-select the specific variant
        if (variant.id === preselectedVariantId) {
            option.selected = true;
        }

        select.appendChild(option);
    });

    select.addEventListener('change', updatePrices);

    // Trigger initial price update with pre-selected value
    updatePrices();
}

// Populate Modules
function populateModules() {
    const leftContainer = document.getElementById('left-module-group');
    const rightContainer = document.getElementById('right-module-group');

    // Find module variants
    const anoSpinningDisc = products.modules.find(v => v.title.includes('Ano Spinning Disc'));
    const smallTrackpad = products.modules.find(v => v.title.includes('Small Trackpad'));
    const largeTrackpad = products.modules.find(v => v.title.includes('Large Trackpad'));

    // Left Module - Pre-selected Ano Spinning Disc (disabled, can't change)
    if (anoSpinningDisc) {
        const item = document.createElement('div');
        item.className = 'checkbox-item';

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'left-module';
        radio.id = 'left-ano';
        radio.value = anoSpinningDisc.id;
        radio.checked = true;
        radio.disabled = true;
        radio.dataset.price = anoSpinningDisc.priceV2.amount;
        radio.dataset.title = anoSpinningDisc.title;
        radio.addEventListener('change', updatePrices);

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = 'left-ano';
        label.textContent = anoSpinningDisc.title;

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(anoSpinningDisc.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(anoSpinningDisc.priceV2.amount).toFixed(2)}`;

        item.appendChild(radio);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        leftContainer.appendChild(item);

        // Set as selected
        selected.leftModule = {
            id: anoSpinningDisc.id,
            title: anoSpinningDisc.title,
            price: parseFloat(anoSpinningDisc.priceV2.amount)
        };
    }

    // Right Module - Multiple selection for trackpads (checkboxes)
    if (smallTrackpad) {
        const item = document.createElement('div');
        const isOutOfStock = !smallTrackpad.availableForSale || smallTrackpad.quantityAvailable === 0;
        item.className = `checkbox-item ${isOutOfStock ? 'disabled' : ''}`;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'right-module';
        checkbox.id = 'right-small';
        checkbox.value = smallTrackpad.id;
        checkbox.disabled = isOutOfStock;
        checkbox.dataset.price = smallTrackpad.priceV2.amount;
        checkbox.dataset.title = smallTrackpad.title;
        checkbox.addEventListener('change', () => {
            updatePrices();
            updateCollapsedSummary('modules-collapse');
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = 'right-small';
        label.textContent = smallTrackpad.title;
        if (isOutOfStock) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(smallTrackpad.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(smallTrackpad.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        rightContainer.appendChild(item);
    }

    if (largeTrackpad) {
        const item = document.createElement('div');
        const isOutOfStock = !largeTrackpad.availableForSale || largeTrackpad.quantityAvailable === 0;
        item.className = `checkbox-item ${isOutOfStock ? 'disabled' : ''}`;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'right-module';
        checkbox.id = 'right-large';
        checkbox.value = largeTrackpad.id;
        checkbox.disabled = isOutOfStock;
        checkbox.dataset.price = largeTrackpad.priceV2.amount;
        checkbox.dataset.title = largeTrackpad.title;
        checkbox.addEventListener('change', () => {
            updatePrices();
            updateCollapsedSummary('modules-collapse');
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = 'right-large';
        label.textContent = largeTrackpad.title;
        if (isOutOfStock) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(largeTrackpad.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(largeTrackpad.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        rightContainer.appendChild(item);
    }

    // Add italic note about multiple modules
    const note = document.createElement('p');
    note.className = 'note';
    note.style.marginTop = '8px';
    note.innerHTML = '<em>If more than one trackpad is selected, extras will be a right swappable module. Only one trackpad can be built at a time.</em>';
    rightContainer.appendChild(note);

    // Initial price calculation to include left module
    updatePrices();
}

// Populate Switch Type
function populateSwitchType() {
    const typeInputs = document.querySelectorAll('input[name="switch-type"]');
    typeInputs.forEach(input => {
        input.addEventListener('change', (e) => {
            selected.switchType = e.target.value;
            updateSwitchesAvailability();
            updateKeycapsAvailability();
            updateDampeningKitAvailability();

            // If in a preset with auto dampening, update dampening selection
            if (currentPreset !== 'custom' && presets[currentPreset] && presets[currentPreset].dampeningKit === 'auto') {
                autoSelectDampening();
            }

            updatePrices();
        });
    });
}

// Populate Switch Plates (checkboxes)
function populateSwitchPlates() {
    const container = document.getElementById('switch-plate-group');

    if (products.switchPlate.length === 0) {
        container.innerHTML = '<p style="color: #929292; font-size: 14px;">No switch plates available</p>';
        return;
    }

    products.switchPlate.forEach((variant, index) => {
        const item = document.createElement('div');
        item.className = 'checkbox-item';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = `plate-${index}`;
        checkbox.value = variant.id;
        checkbox.dataset.price = variant.priceV2.amount;
        checkbox.dataset.title = variant.title;
        checkbox.addEventListener('change', () => {
            updatePrices();
            updateCollapsedSummary('switch-plate-collapse');
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `plate-${index}`;
        label.textContent = variant.title;

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);

        // Auto-show image for in-stock items with images
        if (variant.image && variant.image.url && variant.availableForSale) {
            createInlineImage(item, variant, variant.productHandle);
        }
    });
}

// Populate Switches
function populateSwitches() {
    const container = document.getElementById('switches-group');

    // Add "Not included" option
    const notIncluded = document.createElement('div');
    notIncluded.className = 'checkbox-item';
    const notCheckbox = document.createElement('input');
    notCheckbox.type = 'radio';
    notCheckbox.name = 'switches-selection';
    notCheckbox.id = 'switches-none';
    notCheckbox.value = 'none';
    notCheckbox.checked = true;
    notCheckbox.dataset.price = '0';
    notCheckbox.dataset.title = 'Not included';
    notCheckbox.addEventListener('change', () => {
        // Uncheck all switch checkboxes
        document.querySelectorAll('input[name="switches"]').forEach(cb => cb.checked = false);
        updateSelectedSwitchType();
        updateCollapsedSummary('switches-collapse');
        updateKeycapsAvailability();
        updatePrices();
    });

    const notLabel = document.createElement('label');
    notLabel.className = 'checkbox-label';
    notLabel.htmlFor = 'switches-none';
    notLabel.textContent = 'Not included';

    const notPrice = document.createElement('span');
    notPrice.className = 'checkbox-price';
    notPrice.textContent = 'RM 0.00';

    notIncluded.appendChild(notCheckbox);
    notIncluded.appendChild(notLabel);
    notIncluded.appendChild(notPrice);
    container.appendChild(notIncluded);

    // Add switch options
    products.switches.forEach((variant, index) => {
        const item = document.createElement('div');

        // Determine switch type
        let switchType = 'MX';
        if (variant.title.includes('LPV1')) switchType = 'LPV1';
        else if (variant.title.includes('LPV2')) switchType = 'LPV2';

        // Check if sufficient stock (need 60 pieces) OR out of stock
        const hasSufficientStock = variant.availableForSale && variant.quantityAvailable >= 60;
        const isOutOfStock = !variant.availableForSale || variant.quantityAvailable === 0;

        item.className = `checkbox-item ${(!hasSufficientStock || isOutOfStock) ? 'disabled' : ''}`;
        item.dataset.switchType = switchType;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'switches';
        checkbox.id = `switch-${index}`;
        checkbox.value = variant.id;
        checkbox.dataset.price = variant.priceV2.amount;
        checkbox.dataset.title = variant.title;
        checkbox.dataset.switchType = switchType;
        checkbox.disabled = !hasSufficientStock;
        checkbox.addEventListener('change', (e) => {
            // Uncheck "Not included" if any switch is selected
            if (e.target.checked) {
                document.getElementById('switches-none').checked = false;
            }
            // Update selected switch type based on checked switches
            updateSelectedSwitchType();
            updateKeycapsAvailability();
            updateCollapsedSummary('switches-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `switch-${index}`;
        label.textContent = variant.title;
        if (!variant.availableForSale) {
            label.textContent += ' (Out of stock)';
        } else if (variant.quantityAvailable < 60) {
            label.textContent += ` (Only ${variant.quantityAvailable} available)`;
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        // Price for 60 pieces
        const totalPrice = parseFloat(variant.priceV2.amount) * 60;
        price.textContent = `RM ${totalPrice.toFixed(2)} (60pcs)`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);

        // Auto-show image for in-stock items with images (sufficient stock >= 60)
        if (variant.image && variant.image.url && hasSufficientStock && !isOutOfStock) {
            createInlineImage(item, variant, variant.productHandle);
        }
    });
}

// Helper function to update selected switch type based on checked switches
function updateSelectedSwitchType() {
    const checkedSwitches = document.querySelectorAll('input[name="switches"]:checked');
    if (checkedSwitches.length > 0) {
        // Collect all unique switch types from checked switches
        const switchTypes = new Set();
        checkedSwitches.forEach(cb => {
            switchTypes.add(cb.dataset.switchType);
        });

        // Store all selected switch types (for keycap filtering)
        selected.selectedSwitch = Array.from(switchTypes);
    } else {
        selected.selectedSwitch = null;
    }
}

// Update switches availability based on switch type
function updateSwitchesAvailability() {
    const switchInputs = document.querySelectorAll('#switches-group input[name="switches"]');
    switchInputs.forEach(input => {

        const inputType = input.dataset.switchType;
        const parentItem = input.closest('.checkbox-item');

        // Check if originally disabled due to insufficient stock
        const wasOriginallyDisabled = parentItem.classList.contains('disabled') &&
            parentItem.querySelector('label').textContent.includes('available');

        let shouldDisable = false;

        if (selected.switchType === 'MX') {
            shouldDisable = inputType !== 'MX';
        } else if (selected.switchType === 'LP') {
            shouldDisable = inputType === 'MX';
        }

        // Don't re-enable if originally disabled due to stock
        if (shouldDisable || wasOriginallyDisabled) {
            parentItem.classList.add('disabled');
            input.disabled = true;
            if (input.checked) {
                input.checked = false;
                updateSelectedSwitchType();
                updateKeycapsAvailability();
                updatePrices();
            }
        } else {
            parentItem.classList.remove('disabled');
            input.disabled = false;
        }
    });
}

// Populate Keycaps
function populateKeycaps() {
    const container = document.getElementById('keycaps-group');

    // Add "Not included" option
    const notIncluded = document.createElement('div');
    notIncluded.className = 'checkbox-item';
    const notCheckbox = document.createElement('input');
    notCheckbox.type = 'radio';
    notCheckbox.name = 'keycaps-selection';
    notCheckbox.id = 'keycaps-none';
    notCheckbox.value = 'none';
    notCheckbox.checked = true;
    notCheckbox.dataset.price = '0';
    notCheckbox.dataset.title = 'Not included';
    notCheckbox.addEventListener('change', () => {
        // Uncheck all keycap checkboxes
        document.querySelectorAll('input[name="keycaps"]').forEach(cb => cb.checked = false);
        updateCollapsedSummary('keycaps-collapse');
        updatePrices();
    });

    const notLabel = document.createElement('label');
    notLabel.className = 'checkbox-label';
    notLabel.htmlFor = 'keycaps-none';
    notLabel.textContent = 'Not included';

    const notPrice = document.createElement('span');
    notPrice.className = 'checkbox-price';
    notPrice.textContent = 'RM 0.00';

    notIncluded.appendChild(notCheckbox);
    notIncluded.appendChild(notLabel);
    notIncluded.appendChild(notPrice);
    container.appendChild(notIncluded);

    // Add MX keycaps (SKU contains LPV2MX)
    products.keycapsMX.forEach((variant, index) => {
        const item = document.createElement('div');
        const isOutOfStock = !variant.availableForSale || variant.quantityAvailable === 0;
        item.className = `checkbox-item ${isOutOfStock ? 'disabled' : ''}`;
        item.dataset.keycapType = 'LPV2MX';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'keycaps';
        checkbox.id = `keycap-mx-${index}`;
        checkbox.value = variant.id;
        checkbox.dataset.price = variant.priceV2.amount;
        checkbox.dataset.title = variant.title;
        checkbox.dataset.keycapType = 'LPV2MX';
        checkbox.disabled = isOutOfStock;
        checkbox.addEventListener('change', (e) => {
            // Uncheck "Not included" if any keycap is selected
            if (e.target.checked) {
                document.getElementById('keycaps-none').checked = false;
            }
            updateCollapsedSummary('keycaps-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `keycap-mx-${index}`;
        label.textContent = variant.title;
        if (isOutOfStock) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);

        // Auto-show image for in-stock items with images
        if (variant.image && variant.image.url && !isOutOfStock) {
            createInlineImage(item, variant, variant.productHandle);
        }
    });

    // Add LPV1 keycaps
    products.keycapsLPV1.forEach((variant, index) => {
        const item = document.createElement('div');
        const isOutOfStock = !variant.availableForSale || variant.quantityAvailable === 0;
        item.className = `checkbox-item ${isOutOfStock ? 'disabled' : ''}`;
        item.dataset.keycapType = 'LPV1';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'keycaps';
        checkbox.id = `keycap-lpv1-${index}`;
        checkbox.value = variant.id;
        checkbox.dataset.price = variant.priceV2.amount;
        checkbox.dataset.title = variant.title;
        checkbox.dataset.keycapType = 'LPV1';
        checkbox.disabled = isOutOfStock;
        checkbox.addEventListener('change', (e) => {
            // Uncheck "Not included" if any keycap is selected
            if (e.target.checked) {
                document.getElementById('keycaps-none').checked = false;
            }
            updateCollapsedSummary('keycaps-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `keycap-lpv1-${index}`;
        label.textContent = variant.title;
        if (isOutOfStock) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);

        // Auto-show image for in-stock items with images
        if (variant.image && variant.image.url && !isOutOfStock) {
            createInlineImage(item, variant, variant.productHandle);
        }
    });
}

// Update keycaps availability based on switch type and selected switch
function updateKeycapsAvailability() {
    const keycapInputs = document.querySelectorAll('#keycaps-group input[name="keycaps"]');
    keycapInputs.forEach(input => {

        const keycapType = input.dataset.keycapType;
        const parentItem = input.closest('.checkbox-item');

        // Check if originally disabled due to being out of stock
        const wasOriginallyDisabled = parentItem.querySelector('label').textContent.includes('Out of stock');

        let shouldDisable = false;

        if (selected.switchType === 'MX') {
            // MX selected: only show LPV2MX keycaps
            shouldDisable = keycapType !== 'LPV2MX';
        } else if (selected.switchType === 'LP') {
            // LP selected: check which switches are selected
            if (selected.selectedSwitch && selected.selectedSwitch.length > 0) {
                // Check if keycap is compatible with any selected switch
                const hasLPV1 = selected.selectedSwitch.includes('LPV1');
                const hasLPV2 = selected.selectedSwitch.includes('LPV2');

                if (hasLPV1 && hasLPV2) {
                    // Both LPV1 and LPV2 selected: show both LPV1 and LPV2MX keycaps
                    shouldDisable = keycapType !== 'LPV1' && keycapType !== 'LPV2MX';
                } else if (hasLPV2) {
                    // Only LPV2 switch: show LPV2MX keycaps (they work with both MX and LPV2)
                    shouldDisable = keycapType !== 'LPV2MX';
                } else if (hasLPV1) {
                    // Only LPV1 switch: only show LPV1 keycaps
                    shouldDisable = keycapType !== 'LPV1';
                }
            } else {
                // No switch selected yet: grey out all
                shouldDisable = true;
            }
        }

        // Don't re-enable if originally disabled due to stock
        if (shouldDisable || wasOriginallyDisabled) {
            parentItem.classList.add('disabled');
            input.disabled = true;
            if (input.checked) {
                input.checked = false;
                updatePrices();
            }
        } else {
            parentItem.classList.remove('disabled');
            input.disabled = false;
        }
    });
}

// Populate Dampening Kit
function populateDampeningKit() {
    const container = document.getElementById('dampening-group');

    // Add "Not included" option
    const notIncluded = document.createElement('div');
    notIncluded.className = 'checkbox-item';
    const notCheckbox = document.createElement('input');
    notCheckbox.type = 'radio';
    notCheckbox.name = 'dampening';
    notCheckbox.id = 'dampening-none';
    notCheckbox.value = 'none';
    notCheckbox.checked = true;
    notCheckbox.dataset.price = '0';
    notCheckbox.dataset.title = 'Not included';
    notCheckbox.addEventListener('change', () => {
        updateCollapsedSummary('dampening-collapse');
        updatePrices();
    });

    const notLabel = document.createElement('label');
    notLabel.className = 'checkbox-label';
    notLabel.htmlFor = 'dampening-none';
    notLabel.textContent = 'Not included';

    const notPrice = document.createElement('span');
    notPrice.className = 'checkbox-price';
    notPrice.textContent = 'RM 0.00';

    notIncluded.appendChild(notCheckbox);
    notIncluded.appendChild(notLabel);
    notIncluded.appendChild(notPrice);
    container.appendChild(notIncluded);

    // Add dampening kit options
    products.dampeningKit.forEach((variant, index) => {
        const item = document.createElement('div');
        const isOutOfStock = !variant.availableForSale || variant.quantityAvailable === 0;
        item.className = `checkbox-item ${isOutOfStock ? 'disabled' : ''}`;
        item.dataset.type = variant.title.includes('LP') ? 'LP' : 'MX';

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'dampening';
        radio.id = `dampening-${index}`;
        radio.value = variant.id;
        radio.disabled = isOutOfStock;
        radio.dataset.price = variant.priceV2.amount;
        radio.dataset.title = variant.title;
        radio.dataset.type = item.dataset.type;
        radio.addEventListener('change', () => {
            updateCollapsedSummary('dampening-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `dampening-${index}`;
        label.textContent = variant.title;
        if (isOutOfStock) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(radio);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);
    });
}

// Update dampening kit availability based on switch type
function updateDampeningKitAvailability() {
    const dampeningInputs = document.querySelectorAll('#dampening-group input[name="dampening"]');
    dampeningInputs.forEach(input => {
        if (input.value === 'none') return; // Skip "Not included"

        const inputType = input.dataset.type;
        const parentItem = input.closest('.checkbox-item');

        // Check if originally disabled due to being out of stock
        const wasOriginallyDisabled = parentItem.querySelector('label').textContent.includes('Out of stock');

        const shouldDisable = inputType !== selected.switchType || wasOriginallyDisabled;

        if (shouldDisable) {
            parentItem.classList.add('disabled');
            input.disabled = true;
            if (input.checked) {
                document.getElementById('dampening-none').checked = true;
                updatePrices();
            }
        } else {
            parentItem.classList.remove('disabled');
            input.disabled = false;
        }
    });
}

// Populate 3D Case
function populateCase3D() {
    const container = document.getElementById('case-3d-group');

    // Add "Not included" option
    const notIncluded = document.createElement('div');
    notIncluded.className = 'checkbox-item';
    const notCheckbox = document.createElement('input');
    notCheckbox.type = 'radio';
    notCheckbox.name = 'case3d';
    notCheckbox.id = 'case-none';
    notCheckbox.value = 'none';
    notCheckbox.checked = true;
    notCheckbox.dataset.price = '0';
    notCheckbox.dataset.title = 'Not included';
    notCheckbox.addEventListener('change', () => {
        updateCollapsedSummary('case-collapse');
        updatePrices();
    });

    const notLabel = document.createElement('label');
    notLabel.className = 'checkbox-label';
    notLabel.htmlFor = 'case-none';
    notLabel.textContent = 'Not included';

    const notPrice = document.createElement('span');
    notPrice.className = 'checkbox-price';
    notPrice.textContent = 'RM 0.00';

    notIncluded.appendChild(notCheckbox);
    notIncluded.appendChild(notLabel);
    notIncluded.appendChild(notPrice);
    container.appendChild(notIncluded);

    // Add 3D Case options
    products.case3D.forEach((variant, index) => {
        const item = document.createElement('div');
        item.className = `checkbox-item ${!variant.availableForSale ? 'disabled' : ''}`;

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'case3d';
        radio.id = `case-${index}`;
        radio.value = variant.id;
        radio.disabled = !variant.availableForSale;
        radio.dataset.price = variant.priceV2.amount;
        radio.dataset.title = variant.title;
        radio.addEventListener('change', () => {
            updateCollapsedSummary('case-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `case-${index}`;
        label.textContent = variant.title;
        if (!variant.availableForSale) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(radio);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);
    });
}

// Populate Bottom Plate
function populateBottomPlate() {
    const container = document.getElementById('bottom-plate-group');

    // Add bottom plate options (checkboxes for multiple selection)
    products.bottomPlate.forEach((variant, index) => {
        const item = document.createElement('div');
        item.className = `checkbox-item ${!variant.availableForSale ? 'disabled' : ''}`;

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = 'bottomplate';
        checkbox.id = `bottom-${index}`;
        checkbox.value = variant.id;
        checkbox.disabled = !variant.availableForSale;
        checkbox.dataset.price = variant.priceV2.amount;
        checkbox.dataset.title = variant.title;
        checkbox.addEventListener('change', () => {
            updateCollapsedSummary('bottom-collapse');
            updatePrices();
        });

        const labelWrapper = document.createElement('div');
        labelWrapper.className = 'checkbox-label-wrapper';

        const label = document.createElement('label');
        label.className = 'checkbox-label';
        label.htmlFor = `bottom-${index}`;
        label.textContent = variant.title;
        if (!variant.availableForSale) {
            label.textContent += ' (Out of stock)';
        }

        labelWrapper.appendChild(label);

        // Add info icon if explanation exists
        const infoText = getVariantInfo(variant.title);
        if (infoText) {
            const infoIcon = createInfoIcon(infoText);
            if (infoIcon) labelWrapper.appendChild(infoIcon);
        }

        const price = document.createElement('span');
        price.className = 'checkbox-price';
        price.textContent = `RM ${parseFloat(variant.priceV2.amount).toFixed(2)}`;

        item.appendChild(checkbox);
        item.appendChild(labelWrapper);
        item.appendChild(price);
        container.appendChild(item);
    });
}

// Update prices
function updatePrices() {
    // Base PCB
    const pcbSelect = document.getElementById('base-pcb');
    const pcbPrice = pcbSelect && pcbSelect.selectedIndex >= 0 && pcbSelect.options[pcbSelect.selectedIndex] ?
        parseFloat(pcbSelect.options[pcbSelect.selectedIndex].dataset.price) : 0;
    selected.basePCB = pcbSelect && pcbSelect.selectedIndex >= 0 && pcbSelect.options[pcbSelect.selectedIndex] ? {
        id: pcbSelect.options[pcbSelect.selectedIndex].value,
        title: pcbSelect.options[pcbSelect.selectedIndex].dataset.title,
        price: pcbPrice
    } : null;

    // Left Module (always selected)
    const leftModulePrice = selected.leftModule ? selected.leftModule.price : 0;

    // Right Modules (multiple checkboxes)
    const rightCheckboxes = document.querySelectorAll('input[name="right-module"]:checked');
    let rightModulesTotal = 0;
    selected.rightModules = [];
    rightCheckboxes.forEach(cb => {
        const price = parseFloat(cb.dataset.price);
        rightModulesTotal += price;
        selected.rightModules.push({
            id: cb.value,
            title: cb.dataset.title,
            price: price
        });
    });

    // Switch Plates (multiple)
    const plateCheckboxes = document.querySelectorAll('#switch-plate-group input[type="checkbox"]:checked');
    let platesTotal = 0;
    selected.switchPlates = [];
    plateCheckboxes.forEach(cb => {
        const price = parseFloat(cb.dataset.price);
        platesTotal += price;
        selected.switchPlates.push({
            id: cb.value,
            title: cb.dataset.title,
            price: price
        });
    });

    // Switches (multiple, 60 pieces each)
    const switchCheckboxes = document.querySelectorAll('input[name="switches"]:checked');
    let switchesTotal = 0;
    selected.switches = [];
    switchCheckboxes.forEach(cb => {
        const price = parseFloat(cb.dataset.price) * 60;
        switchesTotal += price;
        selected.switches.push({
            id: cb.value,
            title: cb.dataset.title,
            price: price,
            quantity: 60
        });
    });

    // Keycaps (multiple)
    const keycapCheckboxes = document.querySelectorAll('input[name="keycaps"]:checked');
    let keycapsTotal = 0;
    selected.keycaps = [];
    keycapCheckboxes.forEach(cb => {
        const price = parseFloat(cb.dataset.price);
        keycapsTotal += price;
        selected.keycaps.push({
            id: cb.value,
            title: cb.dataset.title,
            price: price
        });
    });

    // Dampening Kit
    const dampeningRadio = document.querySelector('input[name="dampening"]:checked');
    const dampeningPrice = dampeningRadio && dampeningRadio.value !== 'none' ? parseFloat(dampeningRadio.dataset.price) : 0;
    selected.dampeningKit = dampeningRadio && dampeningRadio.value !== 'none' ? {
        id: dampeningRadio.value,
        title: dampeningRadio.dataset.title,
        price: dampeningPrice
    } : null;

    // 3D Case
    const caseRadio = document.querySelector('input[name="case3d"]:checked');
    const casePrice = caseRadio && caseRadio.value !== 'none' ? parseFloat(caseRadio.dataset.price) : 0;
    selected.case3D = caseRadio && caseRadio.value !== 'none' ? {
        id: caseRadio.value,
        title: caseRadio.dataset.title,
        price: casePrice
    } : null;

    // Bottom Plates (multiple)
    const bottomCheckboxes = document.querySelectorAll('input[name="bottomplate"]:checked');
    let bottomTotal = 0;
    selected.bottomPlates = [];
    bottomCheckboxes.forEach(cb => {
        const price = parseFloat(cb.dataset.price);
        bottomTotal += price;
        selected.bottomPlates.push({
            id: cb.value,
            title: cb.dataset.title,
            price: price
        });
    });

    // Calculate total
    let total = pcbPrice + leftModulePrice + rightModulesTotal + platesTotal + switchesTotal + keycapsTotal + dampeningPrice + casePrice + bottomTotal;

    // If a preset is selected (not custom), use the preset price
    if (currentPreset !== 'custom' && presets[currentPreset]) {
        // Get the preset price from the displayed preset price (which accounts for market pricing)
        const presetPriceElement = document.getElementById(`preset-${currentPreset}-price`);
        if (presetPriceElement) {
            const presetPriceText = presetPriceElement.textContent.replace('RM ', '').trim();
            const presetTotal = parseFloat(presetPriceText);
            if (!isNaN(presetTotal)) {
                total = presetTotal + switchesTotal + keycapsTotal; // Add switches and keycaps to preset base
            }
        }
    }

    document.getElementById('price-total').textContent = `RM ${total.toFixed(2)}`;
}

// Add to cart function
function addConfiguratorToCart() {
    // Force update prices to ensure selected object is current
    updatePrices();

    console.log('=== ADD TO CART VALIDATION ===');
    console.log('selected.basePCB:', selected.basePCB);
    console.log('selected.leftModule:', selected.leftModule);
    console.log('selected.rightModules:', selected.rightModules);
    console.log('selected.switchPlates:', selected.switchPlates);
    console.log('selected.bottomPlates:', selected.bottomPlates);

    // Validation
    const missing = [];

    if (!selected.basePCB) {
        console.log('❌ Base PCB is missing');
        missing.push('Base PCB');
    }

    if (!selected.leftModule) {
        console.log('❌ Left Module is missing');
        missing.push('Left Module');
    }

    if (selected.rightModules.length === 0) {
        console.log('❌ Right Module is missing');
        missing.push('Right Module (at least one trackpad)');
    }

    if (selected.switchPlates.length === 0) {
        console.log('❌ Switch Plate is missing');
        missing.push('Switch Plate');
    }

    if (selected.bottomPlates.length === 0) {
        console.log('❌ Bottom Plate is missing');
        missing.push('Bottom Plate');
    }

    console.log('Missing items:', missing);

    // Additional note for presets: switches and keycaps are optional
    if (missing.length > 0) {
        const missingText = missing.join('\n- ');
        const presetNote = (currentPreset !== 'custom') ? '\n\nNote: Switches and Keycaps are optional for preset builds.' : '';
        alert('Please select the following required items:\n- ' + missingText + presetNote);
        console.log('🛑 Validation failed - stopping cart creation');
        return;
    }

    console.log('✅ Validation passed - proceeding to cart creation');

    // Build cart items array with variant IDs (numeric only, not full GID)
    const cartItems = [];

    // Add base PCB
    const basePCBId = extractVariantId(selected.basePCB.id);
    if (basePCBId) {
        cartItems.push({ id: basePCBId, quantity: 1 });
    }

    // Add left module
    if (selected.leftModule) {
        const leftModuleId = extractVariantId(selected.leftModule.id);
        if (leftModuleId) {
            cartItems.push({ id: leftModuleId, quantity: 1 });
        }
    }

    // Add right modules
    selected.rightModules.forEach(module => {
        const moduleId = extractVariantId(module.id);
        if (moduleId) {
            cartItems.push({ id: moduleId, quantity: 1 });
        }
    });


    const switchTypeRadio = document.querySelector('input[name="switch-type"]:checked');
    if (switchTypeRadio) {
        cartItems.push({ id: switchTypeRadio.value, quantity: 1 });
    }


    // Add switch plates
    selected.switchPlates.forEach(plate => {
        const plateId = extractVariantId(plate.id);
        if (plateId) {
            cartItems.push({ id: plateId, quantity: 1 });
        }
    });

    // Add switches (60 pieces each)
    selected.switches.forEach(switchItem => {
        const switchId = extractVariantId(switchItem.id);
        if (switchId) {
            cartItems.push({ id: switchId, quantity: 60 });
        }
    });

    // Add keycaps
    selected.keycaps.forEach(keycap => {
        // Check if it's a bundle (has bundleComponents)
        const keycapProduct = [...products.keycapsMX, ...products.keycapsLPV1]
            .find(k => k.id === keycap.id);

        if (keycapProduct && keycapProduct.bundleComponents) {
            // Add bundle components individually
            keycapProduct.bundleComponents.forEach(component => {
                const componentId = extractVariantId(component.id);
                if (componentId) {
                    cartItems.push({ id: componentId, quantity: component.quantity });
                }
            });
        } else {
            // Regular keycap, add normally
            const keycapId = extractVariantId(keycap.id);
            if (keycapId) {
                cartItems.push({ id: keycapId, quantity: 1 });
            }
        }
    });

    // Add dampening kit
    if (selected.dampeningKit) {
        // Check if it's a bundle (has bundleComponents)
        const dampeningProduct = products.dampeningKit.find(d => d.id === selected.dampeningKit.id);

        if (dampeningProduct && dampeningProduct.bundleComponents) {
            // Add bundle components individually
            dampeningProduct.bundleComponents.forEach(component => {
                const componentId = extractVariantId(component.id);
                if (componentId) {
                    cartItems.push({ id: componentId, quantity: component.quantity });
                }
            });
        } else {
            // Regular dampening kit (not a bundle)
            const dampeningId = extractVariantId(selected.dampeningKit.id);
            if (dampeningId) {
                cartItems.push({ id: dampeningId, quantity: 1 });
            }
        }
    }

    // Add 3D case
    if (selected.case3D) {
        const caseId = extractVariantId(selected.case3D.id);
        if (caseId) {
            cartItems.push({ id: caseId, quantity: 1 });
        }
    }

    // Add bottom plates
    selected.bottomPlates.forEach(plate => {
        const plateId = extractVariantId(plate.id);
        if (plateId) {
            cartItems.push({ id: plateId, quantity: 1 });
        }
    });

    // Build Shopify cart URL
    // Format: /cart/VARIANT_ID:QUANTITY,VARIANT_ID:QUANTITY
    const cartParams = cartItems.map(item => `${item.id}:${item.quantity}`).join(',');
    const cartUrl = `https://${SHOPIFY_DOMAIN}/cart/${cartParams}`;

    console.log('Cart URL:', cartUrl);
    console.log('Cart items:', cartItems);

    // Redirect to cart
    window.location.href = cartUrl;
}

// Preset Functions

// Initialize presets: calculate prices, check inventory, add event listeners
function initializePresets() {
    // Calculate and display preset prices
    calculatePresetPrices();

    // Check preset inventory availability
    checkPresetInventory();

    // Add event listeners to preset radio buttons
    const presetRadios = document.querySelectorAll('input[name="preset"]');
    presetRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
            const presetValue = e.target.value;
            if (presetValue === 'custom') {
                currentPreset = 'custom';
            } else {
                currentPreset = presetValue;
                applyPreset(presetValue);
            }
        });
    });

    // Add change detection to all form inputs
    addChangeDetection();
}

// Calculate preset prices and display them
function calculatePresetPrices() {
    Object.keys(presets).forEach(presetKey => {
        const preset = presets[presetKey];
        let total = 0;

        // Base PCB price
        const basePCB = products.basePCB.find(v => v.id === preset.basePCB);
        if (basePCB) total += parseFloat(basePCB.priceV2.amount);

        // Left module price
        const leftModule = products.modules.find(v => v.title === preset.leftModule);
        if (leftModule) total += parseFloat(leftModule.priceV2.amount);

        // Right modules price
        preset.rightModules.forEach(moduleName => {
            const module = products.modules.find(v => v.title === moduleName);
            if (module) total += parseFloat(module.priceV2.amount);
        });

        // Switch plates price
        preset.switchPlates.forEach(plateName => {
            const plate = products.switchPlate.find(v => v.title === plateName);
            if (plate) total += parseFloat(plate.priceV2.amount);
        });

        // Dampening kit price
        if (preset.dampeningKit) {
            if (preset.dampeningKit === 'auto') {
                // For auto, use the dampening kit matching the preset's switch type
                const targetDampening = preset.switchType === 'LP' ? 'LP (Poron+IXPE)' : 'MX (Poron+IXPE)';
                const dampening = products.dampeningKit.find(v => v.title === targetDampening);
                if (dampening) total += parseFloat(dampening.priceV2.amount);
            } else {
                const dampening = products.dampeningKit.find(v => v.title === preset.dampeningKit);
                if (dampening) total += parseFloat(dampening.priceV2.amount);
            }
        }

        // 3D case price (any variant, all have same price)
        if (preset.case3D) {
            const caseItem = products.case3D.find(v => v.availableForSale);
            if (caseItem) total += parseFloat(caseItem.priceV2.amount);
        }

        // Bottom plates price
        preset.bottomPlates.forEach(plateName => {
            const plate = products.bottomPlate.find(v => v.title === plateName);
            if (plate) total += parseFloat(plate.priceV2.amount);
        });

        // Update price display
        const priceElement = document.getElementById(`preset-${presetKey}-price`);
        if (priceElement) {
            priceElement.textContent = `RM ${total.toFixed(2)}`;
        }
    });
}

// Check if all items in preset are available
function checkPresetInventory() {
    Object.keys(presets).forEach(presetKey => {
        const preset = presets[presetKey];
        let allAvailable = true;
        const issues = []; // Track what's missing for debugging

        // Check base PCB
        const basePCB = products.basePCB.find(v => v.id === preset.basePCB);
        if (!basePCB || !basePCB.availableForSale) {
            allAvailable = false;
            issues.push(`Base PCB not found or unavailable`);
        }

        // Check left module
        const leftModule = products.modules.find(v => v.title === preset.leftModule);
        if (!leftModule || !leftModule.availableForSale) {
            allAvailable = false;
            issues.push(`Left module "${preset.leftModule}" not found or unavailable`);
        }

        // Check right modules
        preset.rightModules.forEach(moduleName => {
            const module = products.modules.find(v => v.title === moduleName);
            if (!module || !module.availableForSale || module.quantityAvailable === 0) {
                allAvailable = false;
                issues.push(`Right module "${moduleName}" not found or unavailable`);
            }
        });

        // Check switch plates
        preset.switchPlates.forEach(plateName => {
            const plate = products.switchPlate.find(v => v.title === plateName);
            if (!plate || !plate.availableForSale) {
                allAvailable = false;
                issues.push(`Switch plate "${plateName}" not found or unavailable`);
            }
        });

        // Check dampening kit (if included)
        if (preset.dampeningKit) {
            if (preset.dampeningKit === 'auto') {
                // For auto, check if the dampening kit matching the preset's switch type is available
                const targetDampening = preset.switchType === 'LP' ? 'LP (Poron+IXPE)' : 'MX (Poron+IXPE)';
                const dampening = products.dampeningKit.find(v => v.title === targetDampening);
                if (!dampening || !dampening.availableForSale) {
                    allAvailable = false;
                    issues.push(`Dampening kit "${targetDampening}" not found or unavailable`);
                }
            } else {
                const dampening = products.dampeningKit.find(v => v.title === preset.dampeningKit);
                if (!dampening || !dampening.availableForSale) {
                    allAvailable = false;
                    issues.push(`Dampening kit "${preset.dampeningKit}" not found or unavailable`);
                }
            }
        }

        // Check 3D case (if included)
        if (preset.case3D) {
            const caseItem = products.case3D.find(v => v.availableForSale);
            if (!caseItem) {
                allAvailable = false;
                issues.push(`3D Case not available`);
            }
        }

        // Check bottom plates
        preset.bottomPlates.forEach(plateName => {
            const plate = products.bottomPlate.find(v => v.title === plateName);
            if (!plate || !plate.availableForSale) {
                allAvailable = false;
                issues.push(`Bottom plate "${plateName}" not found or unavailable`);
            }
        });

        // Log results for debugging
        console.log(`Preset "${preset.name}" (${presetKey}):`, allAvailable ? '✅ Available' : '❌ Not Available');
        if (!allAvailable) {
            console.log(`  Issues:`, issues);
        }

        // Disable preset if items not available
        const radioElement = document.getElementById(`preset-${presetKey}`);
        const checkboxItem = radioElement ? radioElement.closest('.checkbox-item') : null;

        if (!allAvailable) {
            if (radioElement) radioElement.disabled = true;
            if (checkboxItem) checkboxItem.classList.add('disabled');
        }
    });
}

// Apply preset selections
function applyPreset(presetKey) {
    const preset = presets[presetKey];
    if (!preset) return;

    // Set flag to prevent change detection during application
    isApplyingPreset = true;

    // Select base PCB
    const basePCBSelect = document.getElementById('base-pcb');
    if (basePCBSelect) {
        const option = Array.from(basePCBSelect.options).find(opt => opt.value === preset.basePCB);
        if (option) basePCBSelect.value = preset.basePCB;
    }

    // Select right modules (left module is always Ano Spinning Disc)
    document.querySelectorAll('input[name="right-module"]').forEach(cb => {
        cb.checked = preset.rightModules.includes(cb.dataset.title);
    });

    // Select switch type
    const switchTypeRadio = document.getElementById(`type-${preset.switchType.toLowerCase()}`);
    if (switchTypeRadio) {
        switchTypeRadio.checked = true;
        selected.switchType = preset.switchType;
        updateSwitchesAvailability();
        updateKeycapsAvailability();
        updateDampeningKitAvailability();
    }

    // Select switch plates
    document.querySelectorAll('#switch-plate-group input[type="checkbox"]').forEach(cb => {
        cb.checked = preset.switchPlates.includes(cb.dataset.title);
    });

    // Select dampening kit
    if (preset.dampeningKit) {
        if (preset.dampeningKit === 'auto') {
            // Auto-select based on current switch type
            const targetDampening = selected.switchType === 'LP' ? 'LP (Poron+IXPE)' : 'MX (Poron+IXPE)';
            const dampeningRadio = Array.from(document.querySelectorAll('input[name="dampening"]'))
                .find(r => r.dataset.title === targetDampening);
            if (dampeningRadio && !dampeningRadio.disabled) {
                dampeningRadio.checked = true;
            } else {
                // If auto-selected dampening not available, select "Not included"
                const noneRadio = document.getElementById('dampening-none');
                if (noneRadio) noneRadio.checked = true;
            }
        } else {
            const dampeningRadio = Array.from(document.querySelectorAll('input[name="dampening"]'))
                .find(r => r.dataset.title === preset.dampeningKit);
            if (dampeningRadio) dampeningRadio.checked = true;
        }
    } else {
        const noneRadio = document.getElementById('dampening-none');
        if (noneRadio) noneRadio.checked = true;
    }

    // Select 3D case
    if (preset.case3D) {
        // Find any available 3D case (all are black)
        const caseRadio = Array.from(document.querySelectorAll('input[name="case3d"]'))
            .find(r => r.value !== 'none' && !r.disabled);
        if (caseRadio) caseRadio.checked = true;
    } else {
        const noneRadio = document.getElementById('case-none');
        if (noneRadio) noneRadio.checked = true;
    }

    // Select bottom plates
    document.querySelectorAll('input[name="bottomplate"]').forEach(cb => {
        cb.checked = preset.bottomPlates.includes(cb.dataset.title);
    });

    // Update summaries
    updateCollapsedSummary('modules-collapse');
    updateCollapsedSummary('switch-plate-collapse');
    updateCollapsedSummary('dampening-collapse');
    updateCollapsedSummary('case-collapse');
    updateCollapsedSummary('bottom-collapse');

    // Update prices
    updatePrices();

    // Collapse all sections
    collapseAllSections();

    // Reset flag after a short delay to allow all updates to complete
    setTimeout(() => {
        isApplyingPreset = false;
    }, 100);
}

// Collapse all sections when preset is selected
function collapseAllSections() {
    const sections = ['modules', 'switch-plate', 'dampening', 'case', 'bottom', 'switches', 'keycaps'];
    sections.forEach(section => {
        const collapseId = `${section}-collapse`;
        const content = document.getElementById(collapseId);
        const icon = document.getElementById(`${section}-icon`);

        if (content && !content.classList.contains('collapsed')) {
            content.classList.add('collapsed');
            if (icon) icon.classList.add('collapsed');
            updateCollapsedSummary(collapseId);
        }
    });
}

// Add change detection to all form inputs
function addChangeDetection() {
    // Monitor all inputs for changes
    const inputs = [
        ...document.querySelectorAll('input[name="right-module"]'),
        ...document.querySelectorAll('input[name="switch-type"]'),
        ...document.querySelectorAll('#switch-plate-group input[type="checkbox"]'),
        ...document.querySelectorAll('input[name="dampening"]'),
        ...document.querySelectorAll('input[name="case3d"]'),
        ...document.querySelectorAll('input[name="bottomplate"]')
    ];

    // Also monitor base PCB select
    const basePCBSelect = document.getElementById('base-pcb');
    if (basePCBSelect) {
        basePCBSelect.addEventListener('change', detectPresetChange);
    }

    inputs.forEach(input => {
        input.addEventListener('change', detectPresetChange);
    });
}

// Detect if user has changed any preset selections
function detectPresetChange() {
    // Skip if currently applying a preset
    if (isApplyingPreset) return;

    // Skip if already on custom build
    if (currentPreset === 'custom') return;

    // Alert user and switch to custom build
    alert("You've customized this preset. Switching to Custom Build.");

    // Switch to custom build
    const customRadio = document.getElementById('preset-custom');
    if (customRadio) customRadio.checked = true;
    currentPreset = 'custom';
}

// Auto-select dampening kit based on current switch type
function autoSelectDampening() {
    const targetDampening = selected.switchType === 'LP' ? 'LP (Poron+IXPE)' : 'MX (Poron+IXPE)';
    const dampeningRadio = Array.from(document.querySelectorAll('input[name="dampening"]'))
        .find(r => r.dataset.title === targetDampening);

    if (dampeningRadio && !dampeningRadio.disabled) {
        isApplyingPreset = true; // Prevent triggering change detection
        dampeningRadio.checked = true;
        updateCollapsedSummary('dampening-collapse');
        updatePrices();
        setTimeout(() => { isApplyingPreset = false; }, 100);
    } else {
        // If target dampening not available, select "Not included"
        const noneRadio = document.getElementById('dampening-none');
        if (noneRadio) {
            isApplyingPreset = true;
            noneRadio.checked = true;
            updateCollapsedSummary('dampening-collapse');
            updatePrices();
            setTimeout(() => { isApplyingPreset = false; }, 100);
        }
    }
}

// Initialize static info icons (MX/LP in liquid file)
function initStaticInfoIcons() {
    document.querySelectorAll('.info-icon[data-info]').forEach(iconElement => {
        const key = iconElement.getAttribute('data-info');
        const tooltipText = variantInfo[key];
        if (tooltipText) {
            const tooltip = document.createElement('span');
            tooltip.className = 'info-tooltip';
            tooltip.textContent = tooltipText;
            document.body.appendChild(tooltip);
            iconElement._tooltip = tooltip;

            const showTooltip = () => {
                tooltip.style.display = 'block';
                const rect = iconElement.getBoundingClientRect();
                const tooltipRect = tooltip.getBoundingClientRect();
                const left = rect.right - tooltipRect.width;
                const top = rect.top - tooltipRect.height - 14;
                const finalLeft = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
                const finalTop = Math.max(10, top);
                tooltip.style.left = finalLeft + 'px';
                tooltip.style.top = finalTop + 'px';
            };

            const hideTooltip = () => {
                tooltip.style.display = 'none';
            };

            iconElement.addEventListener('mouseenter', showTooltip);
            iconElement.addEventListener('mouseleave', hideTooltip);
            iconElement.addEventListener('click', (e) => {
                e.stopPropagation();
                const wasActive = iconElement.classList.contains('active');
                document.querySelectorAll('.info-icon.active').forEach(icon => {
                    icon.classList.remove('active');
                    if (icon._tooltip) icon._tooltip.style.display = 'none';
                });
                if (!wasActive) {
                    iconElement.classList.add('active');
                    showTooltip();
                } else {
                    hideTooltip();
                }
            });
        }
    });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
    initStaticInfoIcons();
    loadProducts();
});
